<template>
  <div v-if="showDialog">
    <div id="zheZao">
      <transition name="pop" appear>
        <div class="modal" role="dialog" :style="'30%'">

          <div style="text-align: left;font-size: 28px;margin-bottom: 20px;">

              {{ title }}

          </div>

          <div class="model-body" >
            <span style="
font-weight: 400;
font-size: 16px;
color: #4A4D51;
line-height: 24px;
text-align: left;
font-style: normal;"><slot></slot></span>
          </div>

          <div class="footer_btn">
            <div class="dis_in_center" v-if="showConfirmButton">
              <div
                   @click="confirm"
                   style="width: 100%;
              color: #FFFFFF;
              line-height: 48px;
              height: 48px;
              background: linear-gradient( 133deg, #F8B029 0%, #F6923D 100%);
              border-radius: 14px;">
                {{ confirmText }}
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CustomDialog',
  components: {},
  model: {
    prop: 'showDialog',
    event: 'change'
  },
  props: {
    info: {
      type: String,
      default: ''
    },
    // 弹框的显示隐藏
    showDialog: {
      type: Boolean,
      default: false
    },
    // 底部按钮大小
    size: {
      type: String,
      default: 'medium'
    },
    // 宽度设置
    width: {
      type: [String, Number],
      default: '600'
    },
    // 是否显示右上角的关闭按钮
    showClose: {
      type: Boolean,
      default: true
    },
    // 弹框标题
    title: {
      type: String,
      default: 'Notification'
    },
    // 确认按钮
    confirmText: {
      type: String,
      default: 'Save'
    },
    // 确认按钮loading
    confirmBtnLoading: {
      type: Boolean,
      default: false
    },
    // 是否显示确认按钮
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    // 是否显示取消按钮
    showCancelButton: {
      type: Boolean,
      default: true
    },
    // 是否禁用确认按钮
    disabled: {
      type: Boolean,
      default: false
    },
    // 确认按钮类型
    confirmBtnType: {
      type: String,
      default: 'primary'
    },
    // 取消按钮类型
    cancelType: {
      type: String,
      default: 'info'
    },
    // 取消按钮文本
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    // 关闭按钮前的事件处理
    beforeClose: {
      type: Function,
      default: () => {
        return true;
      }
    }
  },
  methods: {
    close() {
      const data = this.beforeClose();
      if (!data) return;
      this.$emit('change', false);
    },
    confirm() {
      this.$emit('confirm', false);
    }
  }
};
</script>
<style scoped>
#zheZao {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(7, 7, 7, 0.78);
  z-index: 19;
}

#zheZao .modal {
  width: 70%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  height: max-content;
  box-shadow: 0px 5px 15px 0px rgba(255, 102, 0, 0.3);
  overflow: hidden;
  background: #fff;
  z-index: 999;
  transform: none;
  background: linear-gradient(180deg, #FFFFFF 0%, #E6F3DC 100%);
  border-radius: 57px;
  padding: 36px 30px 29px 30px;
}

#zheZao .model-body {
  text-align: left;
  margin-bottom: 51px;
}

#zheZao .icon-close i {
  cursor: pointer;
}

#zheZao .footer_btn {
  text-align: center;
  padding-bottom: 20px;
  padding-top: 20px;
  border-top: 1px solid #f5f5f5;
}

#zheZao .dis_in_center {
  width: 100%;
  display: inline-block;
  vertical-align: middle;
}


#zheZao .label_1 {
  width: 34px;
  height: 34px;
  position: absolute;
  top: 580px;
  left:48%;
}
</style>



// WEBPACK FOOTER //
// src/components/alert.vue